import React from 'react';
import { Button, Modal } from "semantic-ui-react";

const CouponModal = ({ onCancel }) => {
    return (
        <Modal
        size="tiny"
        onClose={onCancel}
        open
        closeOnDimmerClick={false}
        closeIcon={false}
      >
        <Modal.Content >
          <p>Coupons are only available for Annual subscriptions</p>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary content="Cancel" onClick={onCancel} />
        </Modal.Actions>
      </Modal>
    )
}

export default CouponModal
